import { Component, inject } from '@angular/core';
import { LoaderService } from '../../services/loader.service';
import { CommonModule } from '@angular/common';
import { combineLatest, map } from 'rxjs';
import { ProgressIndicatorComponent } from '../progress-indicator/progress-indicator';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [CommonModule, ProgressIndicatorComponent],
  template: `
    <ng-container *ngIf="viewModel$ | async as vm">
      <div class="global-loader-overlay" *ngIf="vm.blocking">
        <app-progress-indicator variant="overlay" label="Loading..."></app-progress-indicator>
      </div>

      <div class="global-loader-inline" *ngIf="vm.background">
        <app-progress-indicator variant="top-bar" label="Loading"></app-progress-indicator>
      </div>
    </ng-container>
  `,
  styles: [`
    .global-loader-overlay {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1200;
      background: color-mix(in srgb, var(--theme-surface, var(--bs-body-bg)) 86%, transparent);
      backdrop-filter: blur(1px);
      display: flex;
      align-items: center;
      justify-content: center;
      pointer-events: auto;
      cursor: wait;
    }

    .global-loader-inline {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 1190;
      pointer-events: none;
      padding-inline: 0.5rem;
      padding-top: 0.35rem;
    }

    .global-loader-inline app-progress-indicator {
      display: block;
    }
  `]
})
export class LoaderComponent {
  readonly loader = inject(LoaderService);
  readonly viewModel$ = combineLatest([this.loader.isBlocking$, this.loader.isBackground$]).pipe(
    map(([blocking, background]) => ({
      blocking,
      background: background && !blocking
    }))
  );

  constructor() {}
}
